import Decimal from "decimal.js";

import type { Price } from "./exchangeRate";

const prices = [
  { base: "USDT", quote: "USDC", price: new Decimal(1) },
  { base: "UST", quote: "USDC", price: new Decimal(1) },
  { base: "PAI", quote: "USDC", price: new Decimal(1) },
  { base: "USDH", quote: "USDC", price: new Decimal(1) },
  { base: "pUSDT", quote: "pUSDC", price: new Decimal(1) },
  { base: "pUSDC", quote: "USDC", price: new Decimal(1) },
  { base: "CSOL", quote: "CUSDC", price: new Decimal(100) },
  { base: "CUSD", quote: "CUSDC", price: new Decimal(1) },
  { base: "CUSDC", quote: "USDC", price: new Decimal(1) },
  { base: "COFF", quote: "USDC", price: new Decimal(0.5) },
];

export class ConstPriceProvider {
  async prices(): Promise<Array<Price>> {
    return new Promise((resolve, reject) => {
      resolve(prices);
      reject("unkown error");
    });
  }
}
